<h2 matDialogTitle>{{data.title}}</h2>
<mat-dialog-content style="white-space: pre-wrap;" fxLayout="column" fxLayoutGap="16px">
  <span>{{data.content}}</span>
</mat-dialog-content>
<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <button mat-raised-button [matDialogClose] color="primary">Okay</button>
</mat-dialog-actions>